export const Multiple = () => {
	return (
		<div className="flex flex-col gap-2">
			<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
				Esse multiplicador influencia diretamente a forma como a
				pontuação da sua escalação será calculada para os prêmios do
				torneio, cada escalação recebe um multipicador, que é usada para
				distribuir os prêmios de forma proporcional.
			</p>
			<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
				Pontos de Classificação = Valor da inscrição × multiplicadores
				das escolhas corretas Exemplo:
			</p>
			<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
				Exemplo:
			</p>

			<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
				Escalação com 3 escolhas corretas, R$ 1,00 de inscrição:
				<br />• Escolha 1: 1,0x
				<br />• Escolha 2: 1,2x
				<br />• Escolha 3: 1,3x
			</p>
			<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
				Pontos = 1,0 × 1,2 × 1,3 = 1,56
			</p>
			<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
				Se o total de pontos da faixa 3/3 for 1.560, com premiação de R$
				10.000: Premiação = (1,56 / 1.560) × 10.000 = R$ 10,00
			</p>
		</div>
	);
};
